import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import LockIcon from "@mui/icons-material/Lock";
import { IoPersonSharp } from "react-icons/io5";
import url from "../assets/media/profilpic.png";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import RegisterForm, { registerSchema } from "../components/auth/RegisterForm";
import { Formik } from "formik";
import useAuthCalls from "../service/useAuthCalls";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

const Register = () => {
  const { register } = useAuthCalls();
  const { user } = useSelector((state) => state.auth);
  console.log(user);

  return (
    <div className="register">
      <Helmet>
        <title>Register | Blogia</title>
        <meta name="description" content="Register description" />
      </Helmet>
      <Container style={{ marginTop: "1rem" }} maxWidth="lg">
        <Grid
          xs={10}
          md={6}
          justifyContent="center"
          container
          direction="row-reverse"
          rowSpacing={{ sm: 3 }}
          style={{
            borderRadius: "15px",
            margin: "auto",
            backgroundColor: "rgba(255,255,255,0.3)",
          }}
          sx={{
            color: "white",
            p: 2,
          }}
        >
          <Grid item md={12}>
            <Avatar
              sx={{
                backgroundColor: "secondary.light",
                m: "auto",
                width: 40,
                height: 40,
              }}
            >
              <IoPersonSharp size="25" />
            </Avatar>
            <Typography
              variant="h4"
              align="center"
              mb={2}
              color="secondary.light"
            >
              Register
            </Typography>

            <Formik
              initialValues={{
                username: "",
                firstName: "",
                lastName: "",
                image: "",
                city: "",
                bio: "",
                email: "",
                password: "",
              }}
              validationSchema={registerSchema}
              onSubmit={(values, actions) => {
                register(values);
                actions.resetForm();
                actions.setSubmitting(false);
                Swal.fire({
                  title: `Hi ${user}`,
                  text: "Welcome to My Blog.",
                  imageUrl: url,
                  imageWidth: 400,
                  imageHeight: 200,
                  imageAlt: "Custom image",
                });
              }}
              component={(props) => <RegisterForm {...props} />}
            ></Formik>

            {/* <Box sx={{ textAlign: "center", mt: 2 }}>
              <Link to="/">Do you have an account?</Link>
            </Box> */}
          </Grid>

          <Grid item xs={0} sm={7} md={6}>
            {/* <Container>
            <img src={image} alt="" />
          </Container> */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Register;
